<template>
  <div class="activity-item">
    <div class="activity-item-pc">
      <div class="activity-left">
        <div class="activity-left-content">
          <img
            class="OTA"
            :class="{ transition: isDone }"
            :src="activity.activityOTA"
            alt=""
          />
          <div class="verify-button" @click="onVerify">
            {{ isDone ? $t('Verified') : $t('verify') }}
          </div>
        </div>
      </div>
      <div class="activity-right">
        <div class="activity-title">
          <div class="img-wrap">
            <img :src="activity.activityIcon" alt="" />
          </div>
          <span>{{ activity.activityTitle }}</span>
        </div>
        <div
          class="activity-desc"
          :class="{ 'text-ellipsis': isShowMore }"
          ref="activityDescPc"
        >
          {{ activity.activityText }}
        </div>
        <div class="desc-more" v-if="isTextEllipsisPc" @click="showMore">
          <span>{{ moreText }}</span>
          <img src="../assets/images/enter-blue.png" alt="" />
        </div>
        <div class="activity-name-list">
          <div
            class="activity-name-item"
            v-for="(item, index) in activity.activityNameList"
            :key="index"
          >
            <div class="activity-name">
              <div class="name">{{ item.name }}</div>
              <a
                :href="activity.activityUrl"
                class="start-button"
                v-if="index === 0"
                >{{ $t('start') }}</a
              >
            </div>
            <div class="activity-name-desc" v-if="item.desc">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
      <a
        :href="activity.tutorialUrl"
        class="tutorial-wrap"
        v-if="activity.tutorialUrl"
      >
        <span>{{ $t('tutorial') }}</span>
        <img src="../assets/images/enter-on.png" alt="" />
      </a>
    </div>
    <div class="activity-item-mobile">
      <div class="title-content">
        <div class="title-wrap">
          <div class="img-wrap">
            <img :src="activity.activityIcon" alt="" />
          </div>
          <span>{{ activity.activityTitle }}</span>
        </div>
        <a :href="activity.tutorialUrl" class="tutorial-wrap" v-if="activity.tutorialUrl">
          <span>{{ $t('tutorial') }}</span>
          <img src="../assets/images/enter-on.png" alt="" />
        </a>
      </div>
      <div class="activity-content">
        <div class="activity-left">
          <div class="activity-left-content">
            <img class="OTA" :class="{ transition: isDone }" :src="activity.activityOTA" alt="" />
            <div class="verify-button" @click="onVerify">
              {{ isDone ? $t('Verified') : $t('verify') }}
            </div>
          </div>
        </div>
        <div class="activity-right">
          <!-- {{ activity.activityText }} -->
          <div
            class="activity-desc"
            :class="{ 'text-ellipsis': isShowMore }"
            ref="activityDescMobile"
          >
            {{ activity.activityText }}
          </div>
          <div class="desc-more" v-if="isTextEllipsisMobile" @click="showMore">
            <span>{{ moreText }}</span>
            <img
              :class="{ up: isShowMore }"
              src="../assets/images/enter-blue.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="activity-name-list">
        <div
          class="activity-name-item"
          v-for="(item, index) in activity.activityNameList"
          :key="index"
        >
          <div class="activity-name">
            <div class="name">{{ item.name }}</div>
          </div>
          <div class="activity-name-desc" v-if="item.desc">
            {{ item.desc }}
          </div>
        </div>
        <a :href="activity.activityUrl" class="start-button">{{
          $t('start')
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import activity from '../mixins/activity';
export default {
  // mixins: [activity],
  props: {
    activity: {
      type: Object,
    },
  },
  data() {
    return {
      isDone: false,
      isTextEllipsisPc: false,
      isTextEllipsisMobile: false,
      isShowMore: false,
    };
  },
  computed: {
    ...mapGetters(['address']),
    moreText() {
      if (this.isShowMore) {
        return this.$t('close');
      } else {
        return this.$t('more');
      }
    },
  },
  watch: {
    address(val) {
      this.fetchActivityStatus(this.activity.activityId, val);
    },
    '$i18n.locale'() {
      this.updateTextEllipsis();
    },
  },
  mounted() {
    this.updateTextEllipsis();
  },
  methods: {
    updateTextEllipsis() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.getHeight();
        }, 5);
      });
    },
    showMore() {
      this.isShowMore = !this.isShowMore;
    },
    getHeight() {
      // 获取元素
      var elementPc = this.$refs.activityDescPc;
      var elementMobile = this.$refs.activityDescMobile;
      // console.log('element', this.$refs);
      // console.log('offsetHeight', element.offsetHeight);
      // console.log('scrollHeight', element.scrollHeight);
      // 判断是否溢出
      if (elementPc) {
        if (elementPc.offsetHeight < elementPc.scrollHeight) {
          // console.log('文本溢出了，被隐藏了！');
          this.isTextEllipsisPc = true;
        } else {
          this.isTextEllipsisPc = false;
          // console.log('文本没有溢出，未被隐藏。');
        }
      }
      if (elementMobile) {
        if (elementMobile.offsetHeight < elementMobile.scrollHeight) {
          // console.log('文本溢出了，被隐藏了！');
          this.isTextEllipsisMobile = true;
        } else {
          this.isTextEllipsisMobile = false;
          // console.log('文本没有溢出，未被隐藏。');
        }
      }
    },
    async onVerify() {
      await this.fetchActivityStatus(this.activity.activityId, this.address);
      if (!this.isDone) {
        window.open(
          `https://galxe.com/TokenPocket/campaign/${this.activity.activityId}`,
          '_self'
        );
      }
    },
    async fetchActivityStatus(activityId, address) {
      if (!activityId || !address) {
        return;
      }
      // const graphqlEndpoint = 'https://graphigo.prd.galaxy.eco/query';
      const graphqlEndpoint =
        // 'https://forwardtest.mytokenpocket.vip/v1/activities/query';
        'https://forward.mytokenpocket.vip/v1/activities/query';
      // GraphQL查询
      const graphqlQuery = `
        {
          campaign(id: "${activityId}") {
            userParticipants(
              address: "${address}"
              first: 10
            ) {
              totalCount
            }
            participationStatus(
              address: "${address}"
            )
          }
        }
      `;
      try {
        const response = await fetch(graphqlEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: graphqlQuery,
          }),
        });
        const res = await response.json();
        // console.log(
        //   'fetchActivityStatus',
        //   res.data.data.campaign.participationStatus
        // );
        if (
          res.data &&
          res.data.data &&
          res.data.data.campaign.participationStatus &&
          res.data.data.campaign.participationStatus === 'Success'
        ) {
          this.isDone = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-item {
  &:nth-child(n + 2) {
    margin-top: 0.2rem;
  }
  .activity-item-pc {
    position: relative;
    padding: 0.24rem;
    border: 0.01rem solid #e3e3e3;
    border-radius: 0.24rem;
    box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.07);
    display: flex;
    cursor: pointer;
    .activity-left {
      position: relative;
      width: 1.76rem;
      height: 2.38rem;
      background: #000000;
      border: 0.01rem solid #e3e3e3;
      border-radius: 0.24rem;
      box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
      .activity-left-content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1.68rem;
        height: 2.3rem;
        border: 0.01rem solid #2980fe;
        border-radius: 0.2rem;
        box-sizing: border-box;
        .OTA {
          margin-top: 0.08rem;
          width: 1.48rem;
          background-color: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(0.1rem);
          -webkit-backdrop-filter: blur(0.05rem);
          border-radius: 0.2rem;
          filter: blur(10px);
          &.transition {
            background: none;
            filter: none;
            transition: all 1s;
          }
        }
        .verify-button {
          position: absolute;
          left: 50%;
          bottom: 0.2rem;
          transform: translateX(-50%);
          width: 1.12rem;
          height: 0.32rem;
          line-height: 0.32rem;
          font-size: 0.12rem;
          font-family: Poppins-Medium;
          text-align: center;
          color: #ffffff;
          border: 0.01rem solid #2980fe;
          border-radius: 0.18rem;
          background: rgba(41, 128, 254, 0.52);
          cursor: pointer;
        }
      }
    }
    .activity-right {
      flex: 1;
      margin-left: 0.24rem;
      .activity-title {
        display: flex;
        align-items: center;
        .img-wrap {
          width: 0.44rem;
          height: 0.44rem;
          display: flex;
          align-items: center;
          img {
            width: 100%;
            border-radius: 50%;
          }
        }
        span {
          margin-left: 0.16rem;
          font-size: 0.22rem;
          font-family: Poppins-Semibold;
          color: #2a2a2a;
        }
      }
      .activity-desc {
        margin-top: 0.08rem;
        font-size: 0.12rem;
        font-family: Poppins-Regular;
        color: #2a2a2a;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        overflow: hidden;
        &.text-ellipsis {
          -webkit-line-clamp: 99;
        }
      }
      .desc-more {
        display: flex;
        align-items: center;
        cursor: pointer;
        span {
          font-size: 0.12rem;
          font-family: Poppins-Regular;
          color: #2980fe;
        }
        img {
          width: 0.1rem;
          height: 0.1rem;
        }
      }
      .activity-name-list {
        margin-top: 0.16rem;
        background: #f5f5f5;
        border: 0.01rem solid #e3e3e3;
        border-radius: 0.12rem;
        padding: 0.12rem;
        .activity-name-item {
          &:nth-child(n + 2) {
            margin-top: 0.16rem;
          }
          .activity-name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 0.14rem;
              font-family: Poppins-Semibold;
              color: #2a2a2a;
              text-align: left;
            }
            .start-button {
              background: #2980fe;
              border-radius: 0.18rem;
              padding: 0.03rem 0.2rem;
              font-size: 0.12rem;
              font-family: Poppins-Medium;
              color: #ffffff;
              cursor: pointer;
            }
          }
          .activity-name-desc {
            margin-top: 0.04rem;
            opacity: 0.6;
            font-size: 0.12rem;
            font-family: Poppins-Regular;
            color: #2a2a2a;
            text-align: left;
          }
        }
      }
    }
    .tutorial-wrap {
      position: absolute;
      right: 0.2rem;
      top: 0.24rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        font-size: 0.12rem;
        font-family: Poppins-Regular;
        color: #2a2a2a;
      }
      img {
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }
  .activity-item-pc:hover {
    .activity-left {
      border: 0.04rem solid #2980fe;
      .verify-button {
        background: #2980fe;
      }
    }
    .activity-right {
      .activity-name-list {
        background: #deebff;
        border: 0.01rem solid #2980fe;
      }
    }
  }
  .activity-item-mobile {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .activity-item {
    &:nth-child(n + 2) {
      margin-top: 0.32rem;
    }
    .activity-item-pc {
      display: none;
    }
    .activity-item-mobile {
      display: block;
      padding: 0.32rem;
      border: 0.01rem solid #e3e3e3;
      border-radius: 0.32rem;
      box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.07);
      .title-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-wrap {
          display: flex;
          align-items: center;
          .img-wrap {
            width: 0.56rem;
            height: 0.56rem;
            display: flex;
            align-items: center;
            img {
              width: 100%;
              border-radius: 50%;
            }
          }
          span {
            margin-left: 0.12rem;
            font-size: 0.28rem;
            font-family: Poppins-Semibold;
            color: #2a2a2a;
          }
        }
        .tutorial-wrap {
          display: flex;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 0.26rem;
            font-family: Poppins-Regular;
            color: #2a2a2a;
          }
          img {
            width: 0.24rem;
            height: 0.24rem;
          }
        }
      }
      .activity-content {
        display: flex;
        margin-top: 0.2rem;
        .activity-left {
          position: relative;
          width: 2.04rem;
          height: 2.76rem;
          display: flex;
          justify-content: center;
          background: #000000;
          border: 0.01rem solid #e3e3e3;
          border-radius: 0.28rem;
          .activity-left-content {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1.96rem;
            height: 2.68rem;
            border: 0.01rem solid #2980fe;
            border-radius: 0.28rem;
            box-sizing: border-box;
            .OTA {
              margin-top: 0.12rem;
              width: 1.76rem;
              background-color: rgba(255, 255, 255, 0.2);
              backdrop-filter: blur(10px);
              -webkit-backdrop-filter: blur(5px);
              filter: blur(10px);
              &.transition {
                background: none;
                filter: none;
                transition: all 1s;
              }
            }
            .verify-button {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              bottom: 0.2rem;
              width: 1.32rem;
              height: 0.48rem;
              line-height: 0.48rem;
              opacity: 0.78;
              font-size: 0.26rem;
              font-family: Poppins-Medium;
              text-align: center;
              color: #ffffff;
              background: rgba(41, 128, 254, 0.52);
              border: 0.01rem solid #2980fe;
              border-radius: 0.5rem;
            }
          }
        }
        .activity-right {
          margin-left: 0.36rem;
          flex: 1;
          .activity-desc {
            font-size: 0.26rem;
            font-family: Poppins-Regular;
            color: #2a2a2a;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
            text-overflow: ellipsis;
            overflow: hidden;
            &.text-ellipsis {
              -webkit-line-clamp: 99;
            }
          }
          .desc-more {
            display: flex;
            align-items: center;
            cursor: pointer;
            span {
              font-size: 0.26rem;
              font-family: Poppins-Regular;
              color: #2980fe;
            }
            img {
              width: 0.2rem;
              height: 0.2rem;
              &.up {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
      .activity-name-list {
        display: flex;
        flex-direction: column;
        margin-top: 0.32rem;
        background: #f5f5f5;
        border: 0.01rem solid #e3e3e3;
        border-radius: 0.24rem;
        padding: 0.32rem;
        .activity-name-item {
          &:nth-child(n + 2) {
            margin-top: 0.32rem;
          }
          .activity-name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 0.26rem;
              font-family: Poppins-Semibold;
              color: #2a2a2a;
              text-align: left;
            }
          }

          .activity-name-desc {
            margin-top: 0.08rem;
            opacity: 0.6;
            font-size: 0.26rem;
            font-family: Poppins-Regular;
            // transform: scale(0.92);
            // margin-left: -0.2rem;
            color: #2a2a2a;
            text-align: left;
          }
        }
        .start-button {
          margin-top: 0.18rem;
          align-self: flex-end;
          width: fit-content;
          background: #2980fe;
          border-radius: 0.5rem;
          padding: 0.08rem 0.32rem;
          font-size: 0.22rem;
          font-family: Poppins-Medium;
          color: #fff;
        }
      }
    }
  }
}
</style>
